<template>
  <div class="g-bd">
    <div class="m-login-box">
      <div class="m-login-inner">
        <h2>找回密码</h2>

        <el-form ref="ruleForm" :model="ruleForm" style="padding-right:15px;" :rules="rules">
          <el-form-item prop="mobile">
            <el-input v-model="ruleForm.mobile" autocomplete="off" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              v-model="ruleForm.code"
              autocomplete="off"
              placeholder="请输入验证码"
              style="width: 190px;"
            ></el-input>
            <el-button
              type="primary"
              plain
              class="f-fr"
              style="width:140px; padding: 12px 10px;"
              v-show="sendAuthCode"
              :disabled="codeBtn"
              @click="loginPhoneCode"
            >
              <span>获取短信验证码</span>
            </el-button>
            <el-button
              type="primary"
              plain
              class="f-fr"
              style="width:140px; padding: 12px 10px;"
              v-show="!sendAuthCode"
              disabled="disabled"
            >
              <span>
                <span class="auth_text_blue">{{authTime}}</span>秒后重新获取
              </span>
            </el-button>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="ruleForm.password"
              autocomplete="off"
              placeholder="6-16位密码，不能用空格，区分大小写"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPassword">
            <el-input
              v-model="ruleForm.checkPassword"
              autocomplete="off"
              placeholder="请确认新密码"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item class style="margin-top: 40px;">
            <el-button
              type="primary"
              class="send-btn"
              :icon="backSuccess?'el-icon-check':''"
              :loading="loading"
              :disabled="allowed||backSuccess"
              @click="save"
            >
              <span>提 交</span>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <DialogSendCode
      ref="dialogSelect"
      :sendCodeDialogVisible="sendCodeDialogVisible"
      @close-dialog="onCloseDialog"
      @confirm-dialog="onConfirmDialog"
    ></DialogSendCode>
  </div>
</template>

<script>
import DialogSendCode from "@/components/dialog/DialogSendCode";
export default {
  components: {
    DialogSendCode
  },
  name: "FindPassword",
  data() {
    let check = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("密码不一致，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      show: true,
      sendAuthCode: true,
      authTime: 0,
      loading: false,
      backSuccess: false,
      ruleForm: {
        mobile: "",
        code: "",
        password: "",
        checkPassword: ""
      },
      rules: {
        mobile: {
          required: true,
          message: "请输入正确的手机号",
          type: "string",
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          trigger: "blur"
        },
        code: { required: true, message: "请输入短信验证码", trigger: "blur" },
        password: { required: true, message: "请输入新密码", trigger: "blur" },
        checkPassword: { required: true, validator: check, trigger: "blur" }
      },
      sendCodeDialogVisible:false
    };
  },
  computed: {
    allowed() {
      return (
        this.ruleForm.mobile == "" ||
        this.ruleForm.code == "" ||
        this.ruleForm.password == "" ||
        this.ruleForm.checkPassword == ""
      );
    },
    codeBtn() {
      return !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.ruleForm.mobile);
    }
  },
  methods: { 
    //关闭发送验证码弹框
    onCloseDialog() {
      this.sendCodeDialogVisible = false;
    },
    //验证码弹框确认
    onConfirmDialog(data) {
      this.sendCodeDialogVisible = false;
      this.send(data);
    },
    //登陆发送手机验证码
    loginPhoneCode() {
      var storage = window.localStorage;
      if (storage["countdown"] > new Date().valueOf()) {
        this.btnBoolen = true;
        this.$message.error("短期内不可再次获取，请稍后重试");
        return false;
      }
      this.sendCodeDialogVisible = true;
    },
    send(data){
       var storage = window.localStorage;
       this.$http
        .post("/api/web/uuc/sendSms", {
          mobile: this.ruleForm.mobile,
          type: 2,
          captchaToken: data.captchaToken,
          captchaAnswer: data.captchaAnswer
        })
        .then(res => {
          this.sendAuthCode = false;
          this.authTime = 60;

          storage["countdown"] = new Date().valueOf() + 60 * 1000;
          let authTimer = setInterval(() => {
            this.authTime--;
            if (this.authTime <= 0) {
              this.sendAuthCode = true;
              clearInterval(authTimer);
            }
          }, 1000);
          this.$message.success("发送验证码成功");
        })
        .catch(({ msg }) => {
          this.$message.error(msg);
        });
    },
    save() {
      this.loading = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$http
            .post("/api/web/uuc/backPassword", this.ruleForm)
            .then(json => {
              // console.log(json);
              this.loading = false;
              this.backSuccess = true;
              this.$message({
                message: json.msg,
                type: "success",
                duration: 1000,
                onClose: () => {
                  location.href = "/login";
                }
              });
            })
            .catch((msg) => {
              this.loading = false;
              this.$message.error(msg.msg);
            });
        } else {
          this.loading = false;
          return false;
        }
      });
    }
  }
};
</script>